import { Modal, ModalProps } from 'ui';

import { CreateHyperWalletAccount } from '../../forms/CreateHyperWalletAccount/CreateHyperWalletAccount';

interface CreateHyperWalletAccountModalProps extends ModalProps {
  modalProps?: Partial<ModalProps>;
  onCreateAccount: () => void;
}

const CreateHyperWalletAccountModal = ({
  opened,
  onClose,
  modalProps,
  title,
  onCreateAccount,
}: CreateHyperWalletAccountModalProps) => {
  return (
    <Modal opened={opened} onClose={onClose} title={title ?? 'Connect Account'} {...modalProps}>
      <CreateHyperWalletAccount onCreateAccount={onCreateAccount} />
    </Modal>
  );
};

export { CreateHyperWalletAccountModal };
